import AuthorListCardListContainer from './parts/AuthorListCardListContainer';

import { Skeleton } from '@/shared/Components';

const TrendingAuthorSkeleton = () => {
  return (
    <AuthorListCardListContainer>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          className="h-[357px] w-[280px] shrink-0 tablet:h-[260px] desktop:h-[377px] desktop:w-[360px]"
        />
      ))}
    </AuthorListCardListContainer>
  );
};

export default TrendingAuthorSkeleton;
